const percentDataFormatOptions = [
  // { value: 'number', label: 'Измерение в числах' },
  { value: 'number', label: 'Numbers' },
  // { value: 'percent', label: 'Измерение в процентах' },
  { value: 'percent', label: 'Percents' },
];
export default percentDataFormatOptions;
